document.getElementById('copy-email').addEventListener('click',async()=>{
 const subject=document.getElementById('email-subject').textContent.trim();
 const body=document.getElementById('email-body');
 const textWithLinks=p=>{let value=p.innerText.trim();p.querySelectorAll('a').forEach(a=>{value=value.replace(a.innerText,a.innerText+' ('+a.href+')');});return value;};
 const paragraphs=Array.from(body.children).map(p=>p.matches('ul,ol')?Array.from(p.children).map(li=>'• '+textWithLinks(li)).join('\n'):textWithLinks(p));
 const text='Subject: '+subject+'\n\n'+paragraphs.join('\n\n');
 const html='<p style="margin:0 0 1em"><strong>Subject: </strong>'+subject+'</p>'+body.innerHTML;
 const status=document.getElementById('copy-status');
 try{
  if(navigator.clipboard&&window.ClipboardItem){await navigator.clipboard.write([new ClipboardItem({'text/html':new Blob([html],{type:'text/html'}),'text/plain':new Blob([text],{type:'text/plain'})})]);}
  else if(navigator.clipboard){await navigator.clipboard.writeText(text);}
  else{throw new Error('Clipboard unavailable');}
  status.textContent='Copied. Paste into a new email, move the subject into the subject field, and personalize the bracketed details.';
 }catch(e){
  const selection=window.getSelection();const range=document.createRange();range.selectNodeContents(document.querySelector('.email'));selection.removeAllRanges();selection.addRange(range);
  status.textContent='The template is selected. Use your device’s Copy command, then paste it into a new email and personalize the bracketed details.';
 }
});
